import React, {useMemo} from 'react';

import {ContextNodesTableColumn} from "../../Common/FileBrowser/ContextNodesTableColumn";
import {StreamBankTable} from "../../Common/Table/StreamBankTable";
import {BenefitValueTableColumn} from "../../Common/Tables/BenefitValueTableColumn";
import {useBenefitValuesGroupedByEnvironmentalBenefitId} from "../../../Hooks/BenefitHooks";
import {service as UnitService} from "../../../Services/UnitService";
import {usePrimeCache} from "../../../Hooks/ServiceHooks";
import {FundersTableColumn} from "../../Common/FileBrowser/FundersTableColumn";
import {usePermission} from "../../../Hooks/PermissionHooks";


const columnDefs = [
    {
        title: "Project",
        key: "project",
        sortable: true,
        logic: (x) => [x],
        sortLogic: (x, sortAsc) => {
            return x ? `${(x?.contextNodeTypeId)} ${x?.name}` : null;
        },
        headerClassName: "project",
        renderer: ContextNodesTableColumn,
        rendererProps: (x) => ({ contextNode: x, useShortName: false })
    },
    {
        title: "Funders",
        key: "funders",
        sortable: true,
        logic: (x) => x.Funders?.length ? x.Funders : '',
        headerClassName: "funders",
        renderer: FundersTableColumn,
    },
];

export const LedgerTable = React.forwardRef((props, ref) => {
    
    const {
        textFilter,
        benefitValues,
        environmentalBenefits,
        metricName = 'benefitValue',
        totalContextNodeId = null,
        addToSearch = () => {},
    } = props;
    
    usePrimeCache([UnitService]);
    
    const hasPermission = usePermission();
    const canSeeFunders = hasPermission("view_funder");
    
    const benefitValuesByEnvironmentalBenefitId = useBenefitValuesGroupedByEnvironmentalBenefitId(benefitValues, totalContextNodeId, textFilter);
    
    
    
    const environmentalBenefitColumnDefs = (environmentalBenefits?.map(
        (environmentalBenefit) => {
            const unit = UnitService.CachedValueById(environmentalBenefit?.unitId)?.result
            const [fullUnitLabel, cellUnitLabel, headerUnitLabel] = unit?.abbreviation?.match(/(.*?)(\/year)?$/) ?? [];
            
            return ({
                title: `${environmentalBenefit?.name} ${headerUnitLabel ? headerUnitLabel : ''}`,
                key: environmentalBenefit?.environmentalBenefitId,
                sortable: true,
                headerClassName: "environmental-benefit",
                logic: (rowData) => rowData?.EnvironmentalBenefits?.[environmentalBenefit?.environmentalBenefitId]?.[metricName],
                // logic: logicByEnvironmentalBenefitId(environmentalBenefit.environmentalBenefitId),
                renderer: BenefitValueTableColumn,
                rendererProps: {suffix: cellUnitLabel}
            })
        }) ?? []);
    
    const benefitColumnDefs = useMemo(() => [
            ...columnDefs.filter((column) => (column.key !== 'funders' || canSeeFunders)),
            ...environmentalBenefitColumnDefs
        ],
        [columnDefs, environmentalBenefits, canSeeFunders]
    );
    
    return <StreamBankTable
        
        Data={benefitValuesByEnvironmentalBenefitId}
        columnDefs={benefitColumnDefs}
        itemNamePlural="benefits"
        getKeyForRow={x => x.contextNodeId}

        sortColumn="project"
        sortAsc={true}
        
        pageSize={100}
        stickyHeader={true}
        
        ref={ref}

        {...props}

    />
});
